import React, { useState } from 'react';

import { Checkbox } from 'shadcn/components/ui/Checkbox';
import { Label } from 'shadcn/components/ui/Label';
import { FormComponent } from 'shared';

import { SourceSelector } from './SourceSelector';

function LocationAccuracyRangeAndSourceSelection({ initialEndDate, initialStartDate, onSubmit }) {
    const incompleteId = 'incomplete-checkbox';
    const excludeReplenId = 'exclude-replenishment-checkbox';

    const [selectedSources, setSelectedSources] = useState([]);
    const [showIncomplete, setShowIncomplete] = useState(false);
    const [excludeReplenishment, setExcludeReplenishment] = useState(false);

    const handleSubmit = async (formData) => {
        formData.selectedSources = selectedSources;
        formData.showIncomplete = showIncomplete;
        formData.excludeReplenishment = excludeReplenishment;
        await onSubmit(formData);
    };

    const formFields = [
        {
            name: 'start',
            inputElement: 'date',
            initialValue: initialStartDate,
            gridValue: 5,
            inputProps: {
                required: true,
                size: 'small',
            },
        },
        {
            name: 'end',
            inputElement: 'date',
            initialValue: initialEndDate,
            gridValue: 5,
            inputProps: {
                required: true,
                size: 'small',
            },
        },
    ];

    const formButton = {
        text: 'OK',
        gridValue: 2,
        variant: 'contained',
        color: 'primary',
        className: 'ml-4',
    };

    return (
        <div className="flex w-full justify-center">
            <div className="w-[70%] max-w-full rounded-md bg-muted/60 p-4">
                <div className="flex flex-col flex-wrap items-center">
                    <div className="flex w-full flex-1 flex-wrap items-end justify-center gap-4 pb-4">
                        <div className="flex flex-row w-full">
                            <div className="flex items-center gap-2 flex-1">
                                <Checkbox
                                    id={incompleteId}
                                    checked={showIncomplete}
                                    onCheckedChange={(value) => setShowIncomplete(value === true)}
                                />
                                <Label className="cursor-pointer font-normal text-sm" htmlFor={incompleteId}>
                                    Show Incomplete
                                </Label>
                            </div>
                            <div className="flex items-center gap-2 flex-1">
                                <Checkbox
                                    id={excludeReplenId}
                                    checked={excludeReplenishment}
                                    onCheckedChange={(value) => setExcludeReplenishment(value === true)}
                                />
                                <Label className="cursor-pointer font-normal text-sm" htmlFor={excludeReplenId}>
                                    Exclude Replenishment
                                </Label>
                            </div>
                            <SourceSelector
                                className="min-w-[200px] flex-[2]"
                                value={selectedSources}
                                onChange={setSelectedSources}
                            />
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center">
                        <span className="whitespace-nowrap text-sm font-medium leading-none text-foreground">
                            Timeframe:
                        </span>
                        <FormComponent formFields={formFields} button={formButton} onSubmit={handleSubmit} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { LocationAccuracyRangeAndSourceSelection };
